import React, { ComponentPropsWithRef } from 'react'

import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import LineUnlockAltIcon from 'components/Luxkit/Icons/line/LineUnlockAltIcon'
import LineUsdCircleIcon from 'components/Luxkit/Icons/line/LineUsdCircleIcon'
import SvgIcon from 'components/Luxkit/SvgIcon'
import LineCoffeeIcon from 'components/Luxkit/Icons/line/LineCoffeeIcon'
import LineRoomUpgradeIcon from 'components/Luxkit/Icons/line/LineRoomUpgradeIcon'

export const SUPPORTED_BENEFITS_ICONS: Record<App.LoyaltyBenefitType, typeof SvgIcon> = {
  'hotel-credits': LineUsdCircleIcon,
  'exclusive-offers': LineUnlockAltIcon,
  'priority-support': LinePhoneIcon,
  'daily-breakfast': LineCoffeeIcon,
  'room-upgrade': LineRoomUpgradeIcon,
}

interface Props extends ComponentPropsWithRef<typeof SvgIcon> {
  benefitType: App.LoyaltyBenefitType
}

export default function LuxuryPlusBenefitIcon({ benefitType, ...rest }: Props) {
  const Icon = SUPPORTED_BENEFITS_ICONS[benefitType]
  return <Icon {...rest} />
}
